import { cva } from "class-variance-authority";

export const toastIconVariants = cva(
  "flex rounded-full items-center justify-center h-8 w-8",
  {
    variants: {
      type: {
        success: "bg-badge-emerald text-badge-green",
        error: "bg-badge-red text-badge-red",
        info: "bg-badge-blue text-badge-blue",
        warning: "bg-badge-yellow text-badge-yellow",
      },
    },
  },
);
